import { QueryParams, SortParams } from "..";

export interface ChartReviewLog {
    reviewCompletedOn: string;
    userName: string;
    donorNumber: string;
    note: string;
    caseId?: number;
    donorId?: number;
}

export const DefaultChartReviewLogQueryParams: QueryParams = {
    timeLow: "",
    timeHigh: "",
};

export const DefaultChartReviewLogSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "false",
};
